export default __webpack_public_path__ + "static/media/settings.223051f1.jpg";